import React from 'react';
import { Modal } from 'antd';
import { RocketOutlined } from '@ant-design/icons';

let promptOpen = false;

/**
 * Hộp thoại "Đã có phiên bản mới" — dùng Modal.confirm như mọi xác nhận khác trong app
 * (thay cho notification ở đáy màn hình). "Để sau" không huỷ gì: pwaUpdate vẫn tự cập nhật
 * khi app bị ẩn lần kế tiếp. Chống mở chồng khi service worker báo nhiều lần.
 */
export const showUpdatePrompt = (apply: () => void) => {
  if (promptOpen) return;
  promptOpen = true;

  Modal.confirm({
    title: 'Đã có phiên bản mới',
    icon: <RocketOutlined className="tw-text-primary" />,
    content:
      'Lưu công việc đang làm rồi bấm Cập nhật để dùng bản mới nhất. Nếu để sau, app sẽ tự cập nhật khi bạn chuyển sang tab hoặc ứng dụng khác.',
    okText: 'Cập nhật',
    cancelText: 'Để sau',
    onOk: () => {
      promptOpen = false;
      apply();
    },
    onCancel: () => {
      promptOpen = false;
    },
  });
};

/** Chỉ dùng trong test. */
export const resetUpdatePromptForTests = () => {
  promptOpen = false;
};
